/**
 * Simply format a number using `toLocaleString`
 * @TODO add ability to pass in toLocaleString options
 * @param {String} input
 */
export default input => (Number(input || 0).toLocaleString('en-US'))
